import styled from "styled-components";

export const Section = styled.div`
    padding: 12px 16px;
    height: 108px;
    box-sizing: border-box;
`;

export const SectionHeader = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
`;

export const SectionTitle = styled.div`
    font-size: 12px;
    color: #6a7282;
`;

export const CountBadge = styled.div`
    background: #f4ecfa;
    color: #700ac1;
    border-radius: 999px;
    padding: 2px 6px;
    font-size: 10px;
`;

export const DeviceList = styled.div<{ hasScroll: boolean }>`
    display: flex;
    flex-direction: column;
    gap: 4px;
    margin-top: 8px;
    max-height: 54px;
    padding-right: 4px;

    ${({ hasScroll }) =>
        hasScroll &&
        `
            overflow-y: auto;
        `}
`;

export const StatusDot = styled.div<{ online?: boolean }>`
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: ${({ online }) => (online ? "#05DF72" : "#ADADAD")};
`;

export const DeviceName = styled.div`
    font-size: 12px;
    color: #1e2939;
`;
export const DeviceRow = styled.div`
    display: flex;
    align-items: center;
    width: 100%;
`;

export const DeviceInfo = styled.div`
    display: flex;
    align-items: center;
    gap: 6px;
    flex: 1;
    min-width: 0;
`;

export const DeleteButton = styled.button`
    margin-left: auto;
    border: none;
    background: transparent;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 4px;
    border-radius: 4px;

    &:hover {
        background: #f3f4f6;
    }
`;

export const DeleteIcon = styled.img`
    width: 18px;
    height: 18px;
    object-fit: contain;
    cursor: pointer;
`;

export const MoreDevicesButton = styled.button`
    display: flex;
    align-items: center;
    gap: 4px;
    padding-top: 2px;

    background: transparent;
    border: none;
    cursor: pointer;

    color: #700ac1;
    font-family: Roboto;
    font-size: 12px;
    font-weight: 400;
    line-height: 14px;

    &:hover {
        text-decoration: underline;
    }
`;
export const EmptyState = styled.div`
    min-height: 120px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 20px;
`;

export const EmptyStateIcon = styled.div`
    width: 40px;
    height: 40px;
    background: #f3f4f6;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
`;

export const EmptyStateIconImage = styled.img`
    width: 20px;
    height: 20px;
`;

export const EmptyStateTitle = styled.div`
    margin-top: 16px;
    color: #6a7282;
    font-size: 12px;
    font-family: Roboto, sans-serif;
    font-weight: 400;
    line-height: 14px;
`;

export const EmptyStateMessage = styled.div`
    margin-top: 6px;
    color: #99a1af;
    font-size: 12px;
    font-family: Roboto, sans-serif;
    font-style: italic;
    font-weight: 400;
    line-height: 14px;
    text-align: center;
`;
